import * as tokens from '../../../../../tokens/color.dark.generated.js';
export const systemColorDark = {
    color: {
        foreground: {
            interactive: {
                primary: {
                    100: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_100_DARK,
                    200: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_200_DARK,
                    300: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_300_DARK
                }
            },
            neutral: {
                100: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_100_DARK,
                200: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK,
                300: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_300_DARK,
                800: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_800_DARK
            },
            signal: {
                positive: {
                    100: tokens.SYS_COLOR_FOREGROUND_SIGNAL_POSITVE_100_DARK,
                    200: tokens.SYS_COLOR_FOREGROUND_SIGNAL_POSITVE_200_DARK
                },
                pending: tokens.SYS_COLOR_FOREGROUND_SIGNAL_PENDING_DARK,
                negative: tokens.SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK
            }
        },
        surface: {
            neutral: {
                100: tokens.SYS_COLOR_SURFACE_NEUTRAL_100_DARK,
                200: tokens.SYS_COLOR_SURFACE_NEUTRAL_200_DARK,
                300: tokens.SYS_COLOR_SURFACE_NEUTRAL_300_DARK,
                400: tokens.SYS_COLOR_SURFACE_NEUTRAL_400_DARK,
                500: tokens.SYS_COLOR_SURFACE_NEUTRAL_500_DARK,
                600: tokens.SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
                800: tokens.SYS_COLOR_SURFACE_NEUTRAL_800_DARK
            },
            interactive: {
                primary: {
                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_DARK,
                    200: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_200_DARK
                },
                tertiary: {
                    300: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_300_DARK
                }
            },
            highlight: {
                primary: tokens.SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_DARK
            },
            signal: {
                success: {
                    100: tokens.SYS_COLOR_SURFACE_SIGNAL_SUCCESS_100_DARK,
                    200: tokens.SYS_COLOR_SURFACE_SIGNAL_SUCCESS_200_DARK
                },
                pending: tokens.SYS_COLOR_SURFACE_SIGNAL_PENDING_DARK,
                negative: tokens.SYS_COLOR_SURFACE_SIGNAL_NEGATIVE_DARK,
                focus: tokens.SYS_COLOR_SURFACE_SIGNAL_FOCUS_DARK,
                indicator: {
                    default: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_DEFAULT_DARK,
                    green: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_GREEN_DARK,
                    blue: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_BLUE_DARK,
                    red: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_RED_DARK,
                    yellow: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_YELLOW_DARK,
                    turquoise: tokens.SYS_COLOR_SURFACE_SIGNAL_INDICATOR_TURQUOISE_DARK
                }
            }
        },
        canvas: {
            default: tokens.SYS_COLOR_CANVAS_DEFAULT_DARK
        }
    }
};
//# sourceMappingURL=color.dark.js.map